import React, { type ReactElement } from 'react';

import { AUTHENTICATION_NEED_HELP } from '@framework/constants/insights';
import useTranslation from '@framework/hooks/useTranslation';
import useSalesforceChat from '@framework/salesforce/useSalesforceChat';

import useSendStatelessInsight from '@hooks/useSendStatelessInsight';

import { Button, Skeleton, Text } from 'styled-system';

const GetHelpAction = (): ReactElement | null => {
    const { t } = useTranslation();
    const sendStatelessInsight = useSendStatelessInsight();
    const { openChat, isChatEnabled, isReady } = useSalesforceChat();

    const handleClick = () => {
        openChat();
        sendStatelessInsight(AUTHENTICATION_NEED_HELP);
    };

    if (!isChatEnabled) {
        return null;
    }

    if (!isReady) {
        return <Skeleton width="140px" height="24px" />;
    }

    return (
        <Button size="small" type="ghost" onClick={handleClick}>
            <Text>{t('Contact support')}</Text>
        </Button>
    );
};

export default GetHelpAction;
